import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "api";
import { STATUS } from "utils/status";
import { GetPayload, VendorListState } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/VendorListExtraReducer';

const initialState: VendorListState = {
  vendor: {
    count: undefined,
    results: []
  },
  vendorTaskIds: {
    count: undefined,
    results: []
  },
  template: {},
  analyse: [],
  analyseTaskIDs: [],
  permissions: {},
  error: null,
  getVendorStatus: STATUS.NOT_STARTED,
  createVendorStatus: STATUS.NOT_STARTED,
  createAnalyseStatus: STATUS.NOT_STARTED,
  unallocateBulkVendorStatus: STATUS.NOT_STARTED,
  unallocateAnalyseStatus: STATUS.NOT_STARTED,
  getVendorListMessage: "",
  createBulkVendorMessage: "",
  createAnalyseBulkVendorMessage: "",
  unallocateBulkVendorMessage: "",
  unallocateAnalyseBulkVendorMessage:"",
  createVendorStatusTaskIDs: STATUS.NOT_STARTED,
  createAnalyseStatusTaskIDs: STATUS.NOT_STARTED,
  createBulkVendorMessageTaskIDs: "",
  createAnalyseBulkVendorMessageTaskIDs: "",

  createVendorUnallocateStatusTaskIDs: STATUS.NOT_STARTED,
  createAnalyseUnallocateStatusTaskIDs: STATUS.NOT_STARTED,
  createBulkVendorUnallocateMessageTaskIDs: "",
  createAnalyseBulkVendorUnallocateMessageTaskIDs: "",

  getDownloadTemplateStatus: STATUS.NOT_STARTED,
  getDownloadTemplateMessage: "",
};

export const getVendorList = createAsyncThunk(
  'project/onboarding/vendor/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    const { search, project_id, paginate } = payload;
    try {
      const response = await api.get('project/onboarding/vendor', {
        params: {
          ...(search && { search }),
          ...(project_id && { project_id }),
          ...(paginate && { paginate }),
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }  
    } catch (error:any) {
      return thunkAPI.rejectWithValue(error.res?.data || "Failed to fetch vendor list")
    }
    
  }
);

export const createBulkVendor = createAsyncThunk(
  'task/assign_by_count/vendor/POST',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.post('task/assign_by_count/vendor/', payload);
    const { status, data } = response;
    if (status === 201) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error:any) {
     return thunkAPI.rejectWithValue(error.response?.data.message || "Failed to create vendors") 
    }
  }
);

export const createBulkVendorByTaskIDs = createAsyncThunk(
  'task/assign_by_id/vendor/POST',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.post('task/assign_by_id/vendor/', payload);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error:any) {
     return thunkAPI.rejectWithValue(error.response?.data.message || "Failed to create vendors") 
    }
  }
);

export const createAnalyseBulkVendor = createAsyncThunk(
  '/task/assign_by_count/analyse/vendor/POST',
  async (payload: any, thunkAPI) => {
    const { payload: payload_updated } = payload
    try {
      const response = await api.post('/task/assign_by_count/analyse/vendor/', payload_updated);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error:any) {
     return thunkAPI.rejectWithValue(error.res?.data || "Failed to create bulk vendor analysis")
    }
  }
);

export const createAnalyseBulkVendorByTaskIDs = createAsyncThunk(
  'task/assign_by_id/analyse/vendor/POST',
  async (payload: any, thunkAPI) => {
    const { payload: payload_updated } = payload
    try {
      const response = await api.post('task/assign_by_id/analyse/vendor/', payload_updated);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error:any) {
     return thunkAPI.rejectWithValue(error.res?.data || "Failed to create bulk vendor analysis")
    }
  }
);

export const unallocateBulkVendor = createAsyncThunk(
  'task/unassign_by_count/vendor/',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.patch('task/unassign_by_count/vendor/', payload);
    const { status, data } = response;
    if (status === 201) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error: any) {
     return thunkAPI.rejectWithValue(error.response?.data || "Failed to unallocate bulk vendor") 
    }
  }
);

export const getDownloadTemplate = createAsyncThunk(
  '/template/download/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    const { project_id, template_name, file_type } = payload;
    try {
      const response = await api.get('/template/download', {
        params: {
          ...(project_id && { project_id }),
          ...(template_name && { template_name }),
          ...(file_type && { file_type }),
        },
      });
      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }  
    } catch (error:any) {
      return thunkAPI.rejectWithValue(error.res?.data || "Failed to fetch vendor list")
    }
    
  }
);

export const unallocateBulkVendorByTaskIds = createAsyncThunk(
  ' task/unassign_by_id/vendor/',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.patch('task/unassign_by_id/vendor/', payload);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error: any) {
     return thunkAPI.rejectWithValue(error.response?.data || "Failed to unallocate bulk vendor") 
    }
  }
);

export const unallocateAnalyseBulkVendor = createAsyncThunk(
  'task/unassign_by_count/analyse/vendor/',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.post('task/unassign_by_count/analyse/vendor/', payload);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error:any) {
     return thunkAPI.rejectWithValue(error.res?.data || "Failed to unallocate Analyse bulk vendor")
    }
  }
);

export const unallocateAnalyseBulkVendorByTaskIds = createAsyncThunk(
  'task/unassign_by_id/analyse/vendor/',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.post('task/unassign_by_id/analyse/vendor/', payload);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
    } catch (error:any) {
     return thunkAPI.rejectWithValue(error.res?.data || "Failed to unallocate Analyse bulk vendor")
    }
  }
);

const vendorListSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setCreateVendorStatus(state, action) {
      state.createVendorStatus = action.payload
    },
    setCreateAnalyseStatus(state, action) {
      state.createAnalyseStatus = action.payload
    },
    setCreateVendorStatusTaskIds(state, action) {
      state.createVendorStatusTaskIDs = action.payload
    },
    setCreateAnalyseStatusTaskIds(state, action) {
      state.createAnalyseStatusTaskIDs = action.payload
    },
    setCreateUnallocateVendorStatus(state, action) {
      state.unallocateBulkVendorStatus = action.payload
    },
    setCreateUnallocateAnalyseStatus(state, action) {
      state.unallocateAnalyseStatus = action.payload
    },
    setCreateUnallocateVendorStatusByTaskIDs(state, action) {
      state.createVendorUnallocateStatusTaskIDs = action.payload
    },
    setCreateUnallocateAnalyseStatusByTaskIDs(state, action) {
      state.createAnalyseUnallocateStatusTaskIDs = action.payload
    },
    getDownloadTemplateStatusReset(state, action){
      state.getDownloadTemplateStatus = action.payload
    }
  },
  extraReducers
});

export const { setCreateVendorStatus,setCreateUnallocateVendorStatusByTaskIDs, getDownloadTemplateStatusReset,  setCreateUnallocateAnalyseStatusByTaskIDs, setCreateAnalyseStatus,setCreateAnalyseStatusTaskIds,setCreateVendorStatusTaskIds,setCreateUnallocateAnalyseStatus, setCreateUnallocateVendorStatus } = vendorListSlice.actions
export default vendorListSlice.reducer;


